import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16","key":"svg-0"}]]

const IconFlag3 = createReactComponent('outline', 'flag-3', 'Flag3', __iconNode);

export default IconFlag3;